module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p8.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "fm1"
  }, [_c('b', [_vm._v("Jered Lish, M.S., Gallup-Certified Strengths Coach, GCDF Associate Director of Career Education")])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("(970) 491-5126")])]), _c('p', {
    staticClass: "txc"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "href": "mailto:Jered.Lish@colostate.edu",
      "id": "AGi"
    }
  }, [_vm._v("Jered.Lish@colostate.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "txt1"
  }, [_vm._v("Currently, Jered Lish serves as the Associate Director of Career Education at the Colorado State University, Career Center. Previously, Jered worked at UC San Diego overseeing the pre-med/pre-health advising program and has a passion for developing compassionate and patient-centered future health professionals. Jered additionally helps students with establishing tangible and actionable steps towards their personal and professional career goals and finds his work with college students to be fulfilling and rewarding. On the side, Jered is a music composer and writes strings arrangements for a variety of television commercials and local bands. He additionally enjoys using his certifications as a Gallup Strengths Coach and MBTI instructor to consult organizations and companies on how best to inspire and optimize performance using a strengths-based approach to employee motivation.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a596769e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter09.vue
// module id = 90
// module chunks = 0